/*
  Sort by dropdown – padded option list (Jacobs Digital)

  Chrome and Edge style the list with CSS alone (see sort-dropdown.css), so this
  script does nothing there. In browsers without that support (Firefox, Safari) the
  browser draws the open list itself and ignores padding, so on desktop this script
  shows a matching styled list instead. The real <select> stays in
  the page and keeps doing the work: choosing an option sets its value and fires the
  same "input" and "change" events the theme already listens for, so sorting works
  exactly as before.

  - Desktop (mouse/trackpad) only. Phones and tablets keep their native picker.
  - Works after the theme re-renders the filters with AJAX (event delegation, no
    per-element setup).
  - Keyboard: Space / Enter / Arrow keys / Alt+Down / F4 open the list; arrows,
    Home / End move; Enter or Space picks; Esc or Tab closes.
*/
(function () {
  if (window.__jdSortDropdown) return;
  window.__jdSortDropdown = true;

  // Chrome / Edge: the CSS-only version handles it.
  if (window.CSS && CSS.supports && CSS.supports('appearance', 'base-select')) return;

  var SELECTOR = 'select.facet-filters__sort';
  var LIST_ID = 'jd-sort-list';
  var state = null; // { select, list, items, index }

  function finePointer() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function labelFor(select) {
    if (select.id) {
      var label = document.querySelector('label[for="' + select.id + '"]');
      if (label && label.textContent.trim()) return label.textContent.trim();
    }
    return select.getAttribute('aria-label') || 'Sort by';
  }

  function highlight(i) {
    if (!state) return;
    var items = state.items;
    if (i < 0) i = 0;
    if (i > items.length - 1) i = items.length - 1;
    items.forEach(function (li, n) { li.classList.toggle('is-active', n === i); });
    state.index = i;
    state.list.setAttribute('aria-activedescendant', items[i].id);
    var li = items[i];
    var top = li.offsetTop, bottom = top + li.offsetHeight, list = state.list;
    if (top < list.scrollTop) list.scrollTop = top;
    else if (bottom > list.scrollTop + list.clientHeight) list.scrollTop = bottom - list.clientHeight;
  }

  function position() {
    if (!state) return;
    var r = state.select.getBoundingClientRect();
    var list = state.list;
    list.style.minWidth = Math.max(r.width, 150) + 'px';
    var w = list.offsetWidth, h = list.offsetHeight;
    var left = Math.min(r.left, window.innerWidth - w - 8);
    var top = r.bottom + 6;
    if (top + h > window.innerHeight - 8 && r.top - h - 6 > 8) top = r.top - h - 6; // open upwards if needed
    list.style.left = Math.max(8, left) + 'px';
    list.style.top = top + 'px';
  }

  function close(refocus) {
    if (!state) return;
    // Clear state first: removing the focused list fires "focusout", which must not
    // try to close (and remove) it a second time.
    var current = state;
    state = null;
    current.select.setAttribute('aria-expanded', 'false');
    if (current.list.parentNode) current.list.parentNode.removeChild(current.list);
    if (refocus) current.select.focus({ preventScroll: true });
  }

  function choose(i) {
    if (!state) return;
    var select = state.select;
    var value = state.items[i].getAttribute('data-value');
    close(true);
    if (select.value !== value) {
      select.value = value;
      select.dispatchEvent(new Event('input', { bubbles: true }));
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function open(select, viaKeyboard) {
    close(false);
    var cs = getComputedStyle(select);
    var list = document.createElement('ul');
    list.id = LIST_ID;
    list.className = 'jd-sort-list';
    list.setAttribute('role', 'listbox');
    list.setAttribute('aria-label', labelFor(select));
    list.tabIndex = -1;
    if (viaKeyboard) list.classList.add('is-keyboard');
    list.style.fontFamily = cs.fontFamily;
    list.style.fontSize = cs.fontSize;

    var options = Array.prototype.filter.call(select.options, function (o) { return !o.hidden && !o.disabled; });
    var selectedIndex = 0;
    var items = options.map(function (o, n) {
      var li = document.createElement('li');
      li.id = LIST_ID + '-' + n;
      li.className = 'jd-sort-list__item';
      li.setAttribute('role', 'option');
      li.setAttribute('data-value', o.value);
      li.setAttribute('aria-selected', o.selected ? 'true' : 'false');
      li.textContent = o.textContent.trim();
      if (o.selected) selectedIndex = n;
      list.appendChild(li);
      return li;
    });
    if (!items.length) return;

    document.body.appendChild(list);
    select.setAttribute('aria-expanded', 'true');
    select.setAttribute('aria-controls', LIST_ID);
    state = { select: select, list: list, items: items, index: selectedIndex };
    position();
    highlight(selectedIndex);

    list.addEventListener('mousedown', function (e) { e.preventDefault(); });
    list.addEventListener('mousemove', function (e) {
      list.classList.remove('is-keyboard');
      var li = e.target.closest('.jd-sort-list__item');
      if (li && state) highlight(state.items.indexOf(li));
    });
    list.addEventListener('click', function (e) {
      var li = e.target.closest('.jd-sort-list__item');
      if (li && state) choose(state.items.indexOf(li));
    });
    list.addEventListener('keydown', function (e) {
      if (!state) return;
      list.classList.add('is-keyboard');
      switch (e.key) {
        case 'ArrowDown': e.preventDefault(); highlight(state.index + 1); break;
        case 'ArrowUp': e.preventDefault(); highlight(state.index - 1); break;
        case 'Home': e.preventDefault(); highlight(0); break;
        case 'End': e.preventDefault(); highlight(state.items.length - 1); break;
        case 'Enter':
        case ' ': e.preventDefault(); choose(state.index); break;
        case 'Escape': e.preventDefault(); close(true); break;
        case 'Tab': close(false); break;
      }
    });
    list.addEventListener('focusout', function (e) {
      if (state && state.list === list && !list.contains(e.relatedTarget)) close(false);
    });

    list.focus({ preventScroll: true });
  }

  // Mouse: open our list instead of the browser's.
  document.addEventListener('mousedown', function (e) {
    var select = e.target.closest && e.target.closest(SELECTOR);
    if (select && e.button === 0 && finePointer() && !select.disabled) {
      e.preventDefault();
      if (state && state.select === select) { close(true); return; }
      select.focus({ preventScroll: true });
      open(select);
      return;
    }
    if (state && !state.list.contains(e.target)) close(false);
  }, true);

  // Keyboard on the closed select.
  document.addEventListener('keydown', function (e) {
    var select = e.target.closest && e.target.closest(SELECTOR);
    if (!select || state || !finePointer()) return;
    var opens = e.key === ' ' || e.key === 'Enter' || e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'F4';
    if (opens) {
      e.preventDefault();
      open(select, true);
    }
  }, true);

  // Keep it tidy when the page moves.
  window.addEventListener('resize', function () { close(false); });
  window.addEventListener('scroll', function (e) {
    if (state && !state.list.contains(e.target)) close(false);
  }, true);
})();